import React, { useEffect, useMemo, useState } from "react";
import {
  TIME_PERIODS,
  formatSlotShort,
  groupSlotsByPeriod,
} from "./slotTimeUtils";

const TimeSlotPicker = ({
  currentTimeSlots,
  isPastSlot,
  isSlotBooked,
  selectedSlots,
  onSlotClick,
}) => {
  const grouped = useMemo(
    () => groupSlotsByPeriod(currentTimeSlots, isPastSlot),
    [currentTimeSlots, isPastSlot],
  );

  const periodsWithSlots = useMemo(
    () => TIME_PERIODS.filter((p) => (grouped[p.id]?.length || 0) > 0),
    [grouped],
  );

  const [activePeriod, setActivePeriod] = useState(
    periodsWithSlots[0]?.id || "morning",
  );

  useEffect(() => {
    if (
      periodsWithSlots.length &&
      !periodsWithSlots.find((p) => p.id === activePeriod)
    ) {
      setActivePeriod(periodsWithSlots[0].id);
    }
  }, [periodsWithSlots, activePeriod]);

  if (!periodsWithSlots.length) {
    return (
      <p className="fv-wizard__empty">No slots available for this date.</p>
    );
  }

  const activeSlots = grouped[activePeriod] || [];

  return (
    <div className="fv-times">
      <div className="fv-times__tabs" role="tablist" aria-label="Time of day">
        {periodsWithSlots.map((period) => {
          const isActive = activePeriod === period.id;
          return (
            <button
              key={period.id}
              type="button"
              role="tab"
              aria-selected={isActive}
              className={`fv-times__tab ${isActive ? "is-active" : ""}`}
              onClick={() => setActivePeriod(period.id)}
            >
              <i className={period.icon} aria-hidden="true" />
              {period.label}
            </button>
          );
        })}
      </div>

      <div className="fv-times__picker" role="tabpanel">
        <div className="fv-times__row" role="group" aria-label="Available times">
          {activeSlots.map(({ slot, index }) => {
            const disabled = isSlotBooked(index);
            const selected = selectedSlots.includes(slot);

            return (
              <button
                key={slot + index}
                type="button"
                className={`fv-times__slot ${selected ? "is-selected" : ""} ${
                  disabled ? "is-disabled" : ""
                }`}
                disabled={disabled}
                onClick={() => !disabled && onSlotClick(slot)}
                aria-pressed={selected}
              >
                <span className="fv-times__slot-label">
                  {formatSlotShort(slot)}
                </span>
              </button>
            );
          })}
        </div>
        <p className="fv-times__picker-foot">
          Tap to select · {selectedSlots.length}/3
        </p>
      </div>
    </div>
  );
};

export default TimeSlotPicker;
